import {
    Button,
    Dialog,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Divider,
    LinearProgress
} from '@material-ui/core';
import Axios from "axios";
import { EncryptStorage } from "encrypt-storage";
import React, { useEffect, useMemo, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import SVG from "react-inlinesvg";
import { useSelector } from "react-redux";
import { toAbsoluteUrl } from '../../../../_metronic/_helpers';
import { GetCurrentLawfirm, GetUserId } from '../../../../Functions/General';

const baseStyle = {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '20px',
    borderWidth: 2,
    borderRadius: 2,
    borderColor: '#eeeeee',
    borderStyle: 'dashed',
    backgroundColor: '#fafafa',
    color: '#bdbdbd',
    outline: 'none',
    transition: 'border .24s ease-in-out'
};

const focusedStyle = {
    borderColor: '#2196f3'
};

const acceptStyle = {
    borderColor: '#00e676'
};

const rejectStyle = {
    borderColor: '#ff1744'
};

const img = {
    display: 'block',
    width: 'auto',
    height: '100%',
    maxWidth: '70px',
};

const thumbInner = {
    display: 'flex',
    minWidth: 0,
    overflow: 'hidden'
};

const list = {
    listStyleType: 'none',
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'column',
    paddingLeft: '0px'
};

async function asyncForEach(array, callback){
    for (let index = 0; index < array.length; index++){
        await callback(array[index], index, array);
    }
}

function Upload(props){
    const encryptStorage                = new EncryptStorage("secret-key");
    const decypt_data                   = encryptStorage.getItem("case_details");
    const data                          = decypt_data;
    const client_case_id                = data ? data.case.id : null;
    const user_id                       = GetUserId();
    const [open, setOpen]               = useState(false);
    const [files, setFiles]             = useState([]);
    const {row}                         = props;
    const {setParentFiles}              = props;
    const {source}                      = props;
    const [loading, setLoading]         = useState(false);
    const [disable, setDisable]         = useState(false);
    const [disableCancel, setDisableCancel] = useState(false);
    const [fail, setFailUpload]         = useState(true);
    const [totalSize, setTotalSize]     = useState(0);
    const [uploadLimit, setUploadLimit] = useState(100);
    const [storage, setStorage]         = useState(0);
    const [kb, setKb]                   = useState(0);
    const [mb, setMb]                   = useState(0);
    const { user }                      = useSelector((state) => state.auth);
    const lawfirm                       = GetCurrentLawfirm();
    const 
        {
        acceptedFiles,
        isDragAccept,
        isDragReject,
        getInputProps,
        getRootProps,
        }
                                        = useDropzone({
        multiple: true,
        onDrop: acceptedFiles => {
            setFiles(acceptedFiles.map(file => Object.assign(file, {
                preview: URL.createObjectURL(file),
                progress: 0,
                isSubmitting: 0,
                isError: 0,
            })));
        }
                                        });
    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setFiles([]);
        setOpen(false);
        setDisableCancel(false);
    };

    const style = useMemo(() => ({
        ...baseStyle,
        ...(isDragAccept ? acceptStyle : {}),
        ...(isDragReject ? rejectStyle : {})
    }), [
    isDragAccept,
    isDragReject
    ]);

    const handleFileUpload = async() => {
        setLoading(true);  
        setDisableCancel(true);

        let disableDelete = files.map((item) => {
            item.isSubmitting = 1;
            return item;
        });
        setFiles(disableDelete);

        await asyncForEach(files, async(file,index) => {
            const fileData  = new FormData();
            fileData.append('case_id', client_case_id);
            fileData.append('source', source);
            fileData.append('source_id', row.id);
            fileData.append('uploaded_by', user_id);
            fileData.append('file[]', file);
            await Axios.post("api/file/upload", fileData, {
                onUploadProgress: (progressEvent) => {
                    var percentComplete = Math.round((progressEvent.loaded * 100) / progressEvent.total)
                        let updateFiles = files.map((upfile) => {
                            if(file.path === upfile.path)
                            {
                                upfile.progress = percentComplete;
                            }
                            return upfile;
                        })
                        setFiles(updateFiles);
                        setDisable(true);
                }
            }
            )
            .then(async (res)=>{
                if((files.length - 1) === index)
                {
                    setFiles([]);
                    setLoading(false);
                    setDisable(false);
                    setDisableCancel(false);
                    setOpen(false);
                }
                setParentFiles(res.data.data);
            })
            .catch((error)=>{
                let errorFile = files.map((item, itemIndex) => {
                    if(itemIndex === index )
                    {
                        item.isError = 1;
                    }
                    return item;
                });
                setFailUpload(true);
                setFiles(errorFile);
                setLoading(false);
                setDisable(false);
                setDisableCancel(false);
            })
        });
    };

    const removeFile = file => {
        setFiles(files.filter((row)=> row.name !== file));
    }

    const totalFilesSize = () => {
        let totalFilesSize = files.reduce((sum, current) => {
            return sum + current.size;
        },0);
        let toKB            = totalFilesSize / 1024;
        let toMB            = toKB / 1024;
        setTotalSize(toMB);
    }

    useEffect(()=>{
        totalFilesSize();
        if(files.length === 0)
        {
            setDisable(true);
        }
        else
        {
            setDisable(false);
        }
        if(files.length > 24)
        {
            setDisable(true);
        }
    }, [files]);

    useEffect(()=>{
        if(totalSize > uploadLimit)
        {
            setDisable(true);
        }
    }, [totalSize]);

    useEffect(() => {
    
        
        if(user.lawyerLawfirmDetails){
            Axios.get(`api/lawfirm/usage/${lawfirm.id.id}`)
            .then((res)=>{
                setStorage(res.data.data[0].gigaByte_available);
            });
            Axios.get(`api/lawfirm/usage/total/${lawfirm.id}`)
            .then(async (res)=>{
              let cases = res.data.data[0].cases;
              if(cases.length !== 0)
              {
                let caseFilesSize = [];
                let caseFiles = [];
                await asyncForEach(cases, async (clientCase)=>{
                    caseFiles.push(clientCase.files);
                    await asyncForEach(clientCase.files, (caseFile)=>{
                      caseFilesSize.push(caseFile.size);
                    });
                });
                setKb(caseFilesSize.reduce((partialSum, a) => partialSum + a, 0) / 1024);
                setMb((caseFilesSize.reduce((partialSum, a) => partialSum + a, 0) / 1024) / 1024);
              }
            });
        }
        else{
            Axios.get(`api/lawfirm/usage/${lawfirm.id}`)
            .then((res)=>{
                setStorage(res.data.data[0].gigaByte_available);
            });
            Axios.get(`api/lawfirm/usage/total/${lawfirm.id}`)
            .then(async (res)=>{
              let cases = res.data.data[0].cases;
              if(cases.length !== 0)
              {
                let caseFilesSize = [];
                let caseFiles = [];
                await asyncForEach(cases, async (clientCase)=>{
                    caseFiles.push(clientCase.files);
                    await asyncForEach(clientCase.files, (caseFile)=>{
                      caseFilesSize.push(caseFile.size);
                    });
                });
                setKb(caseFilesSize.reduce((partialSum, a) => partialSum + a, 0) / 1024);
                setMb((caseFilesSize.reduce((partialSum, a) => partialSum + a, 0) / 1024) / 1024);
              }
            });
        }
    
      }, []);

    return(
        <>
        <button
        type="button"
        className="btn btn-primary mr-3 px-5 py-3 my-3"
        onClick={handleClickOpen}
        >
        <span className="svg-icon svg-icon-md svg-icon-white">
            <SVG src={toAbsoluteUrl("/media/svg/icons/Files/Upload.svg")}></SVG>
        </span>
        Upload File(s)
        </button>
        
        <Dialog
        disableEscapeKeyDown={true}
        disableBackdropClick={true}
        fullWidth={true}
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        >
        <DialogTitle id="alert-dialog-title">{"File Upload"}</DialogTitle>
        <Divider className='mb-10'/>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <section className="container">
                <div {...getRootProps({style})}>
                <input {...getInputProps()} />
                    <SVG className="svg-icon-primary" src={toAbsoluteUrl("/media/svg/icons/Files/Upload.svg")}></SVG>
                    <p>Drag 'n' drop some files here, or click to select files</p>
                </div>
                <div className='mt-5'>
                    <div className='d-flex flex-row justify-content-between'>
                    <h4>Files(<span className={files.length > 24 ? 'text-danger' : ''}>{files.length}</span>/24)</h4>
                    <h4><span className={totalSize > uploadLimit ? 'text-danger' : ''}>{totalSize.toFixed(2)}</span>/100MB</h4>
                    </div>
                    <ul style={list}>
                        {
                             files.map((file, index) => (
                                <div className='mb-3'>
                                    <li key={file.path} className="mb-4 d-flex shadow" style={{border: "1px solid white"}}>
                                        <div style={thumbInner} className="align-items-center">
                                            {
                                            file.type === "image/jpeg" || file.type === "image/png" || file.type === "image/jpg" ?
                                            <>
                                            <i className="align-self-center p-3 fas fa-2x fa-image mr-2"></i><h5 style={{marginTop: "7px"}}>{file.name}</h5>
                                            </>
                                            :file.type === "application/pdf" ?
                                            <>
                                            <i className="p-3 fas fa-2x fa-file-pdf mr-2"></i><h5 style={{marginTop: "7px"}}>{file.name}</h5>
                                            </>
                                            :file.type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ?
                                            <>
                                            <i className="p-3 fas fa-2x fa-file-word mr-2"></i><h5 style={{marginTop: "7px"}}>{file.name}</h5>
                                            </>
                                            :file.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ?
                                            <>
                                            <i className="p-3 fas fa-2x fa-file-excel mr-2"></i><h5 style={{marginTop: "7px"}}>{file.name}</h5>
                                            </>
                                            :file.type === "text/plain" ?
                                            <>
                                            <i className="p-3 fas fa-2x fa-file-alt mr-2"></i><h5 style={{marginTop: "7px"}}>{file.name}</h5>
                                            </>
                                            :file.type === "video/mp4" || file.type === "video/mov" ?
                                            <>
                                            <i className="p-3 fas fa-2x fa-file-video mr-2"></i><h5 style={{marginTop: "7px"}}>{file.name}</h5>
                                            </>
                                            :
                                            <>
                                            <i class="p-3 fas fa-2x fa-question-circle mr-2"></i><h5 style={{marginTop: "7px"}}>{file.name}</h5>
                                            </>
                                            }
                                        </div>
                                        {
                                            file.isError ?
                                            <Button className="ml-auto" value={file.path} disabled={file.isSubmitting}>
                                                <i class="fas fa-exclamation-triangle text-danger"></i>
                                            </Button>
                                            :file.progress === 100 ?
                                            <Button className="ml-auto" value={file.path} disabled={file.isSubmitting}>
                                                <i class="fas fa-check text-success"></i>
                                            </Button>
                                            :file.isSubmitting ?
                                            <Button className="ml-auto" value={file.path} disabled={file.isSubmitting}>
                                                <i class="fas fa-spinner fa-spin"></i>
                                            </Button>
                                            :
                                            <Button className="ml-auto" value={file.path} onClick={() => removeFile(file.path)} disabled={file.isSubmitting}>
                                                <i className="ml-3 fa fa-trash text-danger" ></i>
                                            </Button>
                                            
                                        }
                                    </li>
                                    <div hidden={file.isError === 0 ? true : false} className='text-danger'><span>File Upload Failed.</span></div>
                                    <LinearProgress variant="determinate" value={file.progress}/>
                                </div>
                            ))
                        }
                    </ul>
                </div>
            </section>
          <div hidden={true} className='text-danger'><span>You have reached the upload limit of your subscription.</span></div>
          <Divider className="form-bottom-divider"/>
            <Button 
            type="submit" 
            className="btn btn-md btn-success px-9 py-4 my-3" 
            onClick={handleFileUpload}
            disabled={disable}
            >
                Submit
                {loading && (
                    <span className="ml-3 spinner spinner-white"></span>
                )}
            </Button>
            <Button type="submit" className="ml-3 btn btn-md custom-cancel-button px-9 py-4 my-3" onClick={handleClose} disabled={disableCancel}>
                CANCEL
            </Button>
          </DialogContentText>
        </DialogContent>
        </Dialog>
        </>
    )
}
export default Upload